/* import __COLOCATED_TEMPLATE__ from './duration-filter.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class DurationFilter extends Component {
  @service intl;

  @tracked selectedValue = 168;
  isOpen = false;

  constructor() {
    super(...arguments);
    this.selectedValue = this.args.selectedValue || 168;
  }

  get availableItems() {
    return [
      {
        text: this.intl.t('workflow-connector.builder.logs.filter.duration.four-hours'),
        value: 4,
      },
      {
        text: this.intl.t('workflow-connector.builder.logs.filter.duration.tweleve-hours'),
        value: 12,
      },
      {
        text: this.intl.t('workflow-connector.builder.logs.filter.duration.one-day'),
        value: 24,
      },
      {
        text: this.intl.t('workflow-connector.builder.logs.filter.duration.three-days'),
        value: 72,
      },
      {
        text: this.intl.t('workflow-connector.builder.logs.filter.duration.seven-days'),
        value: 168,
      },
    ];
  }

  get items() {
    return this.availableItems.map((item) => ({
      text: item.text,
      value: item.value,
      isSelected: this.selectedValue ? this.selectedValue === item.value : false,
      component: 'workflow-connector/builder/logs/filters/filter-option',
    }));
  }

  get details() {
    let details = '';
    this.availableItems.forEach((item) => {
      if (item.value === this.selectedValue) {
        details = item.text;
      }
    });
    return `is ${details}`;
  }

  @action resetSelectedValue(_element, [selectedValue]) {
    this.onSelectItem(selectedValue || 168, true);
  }

  @action onSelectItem(selectedValue, forced = false) {
    if (this.selectedValue !== selectedValue || forced) {
      this.selectedValue = selectedValue;
    } else {
      this.selectedValue = 168;
    }
  }

  @action onOpen() {
    if (this.isOpen) {
      return;
    }
    this.isOpen = true;
  }

  @action onClose() {
    this.isOpen = false;
    this.args.filterContent('created_at', this.selectedValue || 168);
  }
}
